module.exports = __webpack_public_path__ + "img/icon_fail@3x.3af136dc.png";